/**
 * Where should the simulated boat start when the sim feed comes up?
 *
 * The sim shares one own-ship position with the real device feed. When the
 * skipper switches from Device GNSS to Simulated, the position sitting in the
 * store is the last REAL fix, so seeding the sim there would drop the training
 * boat exactly on the real position and, with no helm command, leave it sat
 * there looking like nothing changed (the fb-ms1is17a-5 report). So we only
 * resume from the current position when that position was itself produced by the
 * simulator; otherwise we reseat the training boat on the practice area.
 *
 * `origin` is which source produced the current position (gnss store), null
 * before the first fix.
 */
import type { PositionSourceKind } from '@/store/positionSource';

/**
 * True when the sim should be reseated on the practice-area default rather than
 * resuming from the current own-ship position: either there's no boat yet, or the
 * position on screen is a leftover real-device fix (we've just switched to sim).
 */
export function shouldReseatSimBoat(
  currentPosition: [number, number] | null | undefined,
  origin: PositionSourceKind | null,
): boolean {
  if (!currentPosition) return true;
  return origin === 'device';
}
